import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import React from 'react';
import I18n from '../../../../i18n/I18n';
import { H } from '../../../../Layout';

type KeyCreditsSourceFooterProps = {
    onBack: () => void;
    onExtract: () => void;
    extractLoading?: boolean;
    extractDisabled?: boolean;
    showBackButton?: boolean;
};

export default function KeyCreditsSourceFooter({
    onBack,
    onExtract,
    extractLoading = false,
    extractDisabled = false,
    showBackButton = false
}: KeyCreditsSourceFooterProps) {
    return (
        <H
            sx={{
                position: 'sticky',
                bottom: 0,
                mt: 'auto',
                py: 1.5,
                px: 1,
                borderTop: '1px solid',
                borderTopColor: 'divider',
                bgcolor: 'background.paper',
                alignItems: 'center',
                justifyContent: showBackButton ? 'space-between' : 'flex-end'
            }}
        >
            {showBackButton ? (
                <Button variant="text" size="small" onClick={onBack} sx={{ textTransform: 'none' }}>
                    <I18n token="dialog.back" />
                </Button>
            ) : null}
            <H sx={{ gap: 1, justifyContent: 'flex-end' }}>
                <LoadingButton
                    variant="contained"
                    size="small"
                    onClick={onExtract}
                    loading={extractLoading}
                    disabled={extractDisabled}
                    sx={{ textTransform: 'none' }}
                >
                    <I18n token="shortlist.key.credits.ai.extract.credits" />
                </LoadingButton>
            </H>
        </H>
    );
}
